// "Someone has invited you" — on every screen, until it is dealt with.
//
// The banner exists for the person who never clicked the link: they signed in
// the way they always do, and nothing in the app would otherwise mention that
// a workspace is waiting for them. It reads from the workspace context, which
// already asked once per session, so it costs no request per page.
//
// It is not shown on the two screens that are already about the invitation.

import { Link, useLocation } from "react-router-dom";
import { useWorkspace } from "../lib/WorkspaceContext";
import { isDismissed } from "../lib/invitations";

export function InvitationNotice() {
  const { invitations } = useWorkspace();
  const { pathname } = useLocation();

  if (pathname === "/invitations" || pathname === "/join") return null;

  const waiting = invitations.filter((i) => !isDismissed(i.id));
  if (waiting.length === 0) return null;

  const first = waiting[0];

  return (
    <div className="notice invite-banner" role="status">
      <span>
        {waiting.length === 1
          ? <>
              {first.invited_by_email ?? "Someone"} invited you to work in{" "}
              <strong>{first.workspace_name}</strong> as <strong>{first.role_name}</strong>.
            </>
          : <>You have <strong>{waiting.length} invitations</strong> waiting.</>}
      </span>
      <span className="spacer" />
      <Link className="button-ish" to="/invitations">
        {waiting.length === 1 ? "Review invitation" : "Review invitations"}
      </Link>
    </div>
  );
}
